import { render, staticRenderFns } from "./CardDataComponent.vue?vue&type=template&id=373faff0&scoped=true&"
import script from "./CardDataComponent.vue?vue&type=script&lang=js&"
export * from "./CardDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardDataComponent.vue?vue&type=style&index=0&id=373faff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373faff0",
  null
  
)

export default component.exports